export const API_ACTIVITY_HOST = import.meta.env.VITE_API_ACTIVITY_HOST;
export const API_SUPPLIER_HOST = import.meta.env.VITE_API_SUPPLIER_HOST;
export const NEO_SUPPLIER_HOST = import.meta.env.VITE_APP_NEO_SUPPLIER_HOST;
